import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, TrashIcon, EditIcon, AddIcon, ViewIcon } from 'assets/icons';
import { RevisionService, SignatureService } from 'services';
import moment from 'moment';
import ModalView from './modal-view';
import { useApacuana } from 'contexts/ApacuanaContext';
import ModalAssignament from '../revision/modal-assignament';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
  assignSignatureToLawyer?: any;
  getFile?: any;
  addSigner?: any;
  initAdminSdk?: any;
  closeAdminSdk?: any;
  init?: any;
}

const INITIAL_STATE = {
  search: '',
  area_id: '',
  person_type_id: '',
  since: '',
  until: '',
};

class AdminSignature extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: [
      'ID Orden',
      'Fecha',
      'Tipo derecho',
      'Tipo persona',
      'Cliente',
      'C.I.',
      'Abogado',
      'Inpre',
      'Estatus',
      'Acciones',
    ],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    areas: [],
    person_types: [],
    visible: false,
    item: null,
    visible_assign: false,
    selected_doc: null,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Firma Electrónica',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.load();
    this.loadData();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await SignatureService.admin.get({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
      since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
      until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
    });
    this.setState({
      data: res.signatures.rows,
      last_page: res.signatures.count,
    });
  };

  loadData = async () => {
    const res: any = await RevisionService.admin.getAreas({
      withoutLoading: true,
    });
    this.setState({
      person_types: res.person_types || [],
      areas: res.areas || [],
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  edit = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible: true,
      item,
    });
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  view = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      item,
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
      item: null,
    });
  };

  getColor = (item: any) => {
    switch (item.status) {
      case Constants.SIGNATURE_STATUS.PENDING:
        return Colors.orange;
        break;

      case Constants.SIGNATURE_STATUS.ACCEPTED:
        return Colors.green;
        break;

      case Constants.SIGNATURE_STATUS.REJECTED:
        return Colors.danger;
        break;
    }
  };

  onOpenAssign = (item: any) => {
    this.setState({
      visible_assign: true,
      item,
    });
  };

  onCloseAssign = (load: boolean = false) => {
    this.setState(
      {
        visible_assign: false,
        item: null,
        selected_doc: null,
      },
      () => load && this.load(true),
    );
  };

  render() {
    const { visible, visible_assign } = this.state;

    return (
      <div id='admin-signature'>
        <Modal
          className='modal-view-signature'
          visible={visible}
          title='Documentos'
          onClose={() => this.onClose()}
        >
          <ModalView item={this.state.item} onClose={() => this.onClose()} />
        </Modal>
        <Modal
          className='modal-assign-lawyer'
          visible={visible_assign}
          title=''
          hideHeader={true}
          onClose={() => this.onCloseAssign()}
        >
          {/* @ts-ignore */}
          <ModalAssignament
            item={this.state.item}
            onClose={() => this.onCloseAssign()}
            onSubmit={async (item: any) => {
              if (!item.apacuanaId) {
                Globals.showWarning(
                  'Este abogado no ha iniciado el proceso de generación de certificado',
                );
              } else {
                const selected_doc: any = this.state.item;
                const signature_id = selected_doc.id;
                const lawyer_id = item.id;
                // const document = item.full_document.split("-")[0];
                // const documentNumber = item.full_document.split("-")[1];
                // await this.props.initAdminSdk(item.apacuanaId);
                // await this.props.init();
                // const selected: any = this.state.selected_doc;
                // if (selected) {
                //   const signerData = {
                //     name: selected.name || "",
                //     reference: "",
                //     typedoc: document,
                //     doc: documentNumber,
                //     signature: [
                //       {
                //         page: 1,
                //         x: parseFloat("60") / 100,
                //         y: parseFloat("80") / 100,
                //       },
                //     ],
                //     file: selected,
                //   };
                const assignData = {
                  signature_id,
                  lawyer_id,
                };
                await this.props.assignSignatureToLawyer(assignData);
                this.onCloseAssign(true);
                // await this.props.closeAdminSdk();
              }
            }}
          />
        </Modal>
        <div className='row row-filter'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-11 row'>
                <div className='col-md-4'>
                  <Input
                    value={this.state.form.search}
                    name='search'
                    placeholder='Nombre del cliente o abogado'
                    label='Buscar'
                    className='input-table'
                    onSubmit={() => this.load()}
                    onChange={(e: any) => {
                      clearTimeout(this.timer);
                      this.timer = setTimeout(() => {
                        this.load(true);
                      }, 1000);
                      this.change(e);
                    }}
                  />
                </div>
                <div className='col-md-2'>
                  <Select
                    color='white'
                    placeholder='Seleccionar'
                    label='Tipo de derecho'
                    name='area_id'
                    onChange={(e: any) =>
                      this.change(e, async () => {
                        this.load(true);
                      })
                    }
                    value={this.state.form.area_id}
                    options={this.state.areas.map((item: any) => {
                      return {
                        value: item.id,
                        label: item.name,
                      };
                    })}
                  />
                </div>
                <div className='col-md-2'>
                  <Select
                    color='white'
                    placeholder='Seleccionar'
                    label='Tipo de persona'
                    name='person_type_id'
                    onChange={(e: any) =>
                      this.change(e, async () => {
                        this.load(true);
                      })
                    }
                    value={this.state.form.person_type_id}
                    options={this.state.person_types.map((item: any) => {
                      return {
                        value: item.id,
                        label: item.name,
                      };
                    })}
                  />
                </div>
                <div className='col-md-2'>
                  <DatePicker
                    label='Desde'
                    placeholder='Desde'
                    onChange={(text: string) => {
                      this.change(
                        {
                          target: {
                            value: text,
                            name: 'since',
                          },
                        },
                        () => this.load(true),
                      );
                    }}
                    value={this.state.form.since}
                  />
                </div>
                <div className='col-md-2'>
                  <DatePicker
                    label='Hasta'
                    placeholder='Hasta'
                    onChange={(text: string) => {
                      this.change(
                        {
                          target: {
                            value: text,
                            name: 'until',
                          },
                        },
                        () => this.load(true),
                      );
                    }}
                    value={this.state.form.until}
                  />
                </div>
              </div>
              <div className='col-md-1'>
                {this.state.form != INITIAL_STATE && (
                  <button className='btn btn-clean' onClick={() => this.reset()}>
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Table title='Firma Electrónica' data={this.state.data.length} header={this.state.header}>
          {this.state.data.map((i: any, index: number) => {
            return (
              <tr key={index}>
                <td>{i.number}</td>
                <td>{moment(i.created_at).format('DD-MM-YYYY')}</td>
                <td>{i.area?.name}</td>
                <td>{i.person_type?.name}</td>
                <td>{i.user?.full_name}</td>
                <td>{i.user?.full_document}</td>
                <td>{i.lawyer?.full_name || '-'}</td>
                <td>{i.lawyer?.lawyer_document || '-'}</td>
                <td>
                  <div className='container-status' style={{ backgroundColor: this.getColor(i) }}>
                    <p>{i.status_text}</p>
                  </div>
                </td>
                <td className='text-right'>
                  <Tooltip title='Ver'>
                    <a
                      className='link-icon'
                      target='_blank'
                      href='#'
                      onClick={(e: any) => this.view(e, i)}
                    >
                      <img src={ViewIcon} />
                    </a>
                  </Tooltip>
                </td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}
const AdminSignatureWithApacuana = (props: Props) => {
  const apacuanaContext: any = useApacuana();
  const [loading, setLoading] = useState(false);
  const assignSignatureToLawyer = async (assignData: any) => {
    setLoading(true);
    try {
      const assign = await assignLawyerByAdmin(assignData);
      // const signer = await addSigner(signerData);
    } catch (err: any) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const initAdminSdk = async (id: any) => {
    await apacuanaContext?.updateSdkConfig(id, false);
  };

  const closeAdminSdk = async () => {
    await apacuanaContext?.updateSdkConfig(undefined, false);
  };

  const getFile = async (item: any) => {
    setLoading(true);
    try {
      const urlCompleta = Constants.BASE_STORAGE + item.file;

      const response = await fetch(urlCompleta);
      if (!response.ok) {
        throw new Error(`Fallo en la descarga: ${response.status} ${response.statusText}`);
      }

      const blob = await response.blob();

      const mimeType = response.headers.get('Content-Type') || 'application/octet-stream';

      const fileName = item.file.split('/').pop();

      const fileObj = new File([blob], fileName, {
        type: mimeType,
      });

      return fileObj;
    } catch (error) {
      console.error('Error al transformar a File:', error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const assignLawyerByAdmin = async (assignData: any) => {
    return await SignatureService.admin.assign(assignData);
  };

  const addSigner = async (signerData: any) => {
    const result = await apacuanaContext?.sdk?.addSigner(signerData);
    return result;
  };

  useEffect(() => {
    if (loading) {
      Globals.setLoading();
    } else {
      Globals.quitLoading();
    }
  }, [loading]);

  async function init() {
    try {
      const docs = await apacuanaContext?.sdk?.getDocsByCustomer({
        page: 0,
        size: 10,
      });
    } catch (err) {
      console.log({ err });
    }
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <AdminSignature
        {...props}
        assignSignatureToLawyer={assignSignatureToLawyer}
        getFile={getFile}
        addSigner={addSigner}
        initAdminSdk={initAdminSdk}
        closeAdminSdk={closeAdminSdk}
        init={init}
      />
    </>
  );
};

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(AdminSignatureWithApacuana);
